import React from 'react';
import { NavLink } from 'react-router-dom';

const website = "https://twitter.com/Jude_Li_Eric"
const About = "I believe in you Jude"

//styles
const styles = {
    navStyle:{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "250px",
        fontSize: "15px"
    },
    startStyle:{
      background: "white",
      color: '#2498f3',
      borderRadius: "20px",
      padding: "1em 1.5em",
    },
    shareStyle:{
        marginLeft: "10px",
        border: '1px solid white',
        padding: "1em 2.5em",
        borderRadius: "21px",
        color: "white"
       
    }
}



const MainNav = (props)=>{
const { navStyle, startStyle, shareStyle } = styles;
    return(
        <nav style={navStyle}>
           <div>
           <NavLink style={startStyle} to="/mainpage">GET STARTED</NavLink>

             <a target="_blank" style={shareStyle}
            href={ "https://twitter.com/home/?status=" +
              About +
              "." +
              " " +
              "~ " +
              website
            }>
            SHARE
          </a>
           </div>
        </nav>
    )
};

export default MainNav;


// WEBPACK FOOTER //
// ./src/components/UI/MainNav.js